import { render, staticRenderFns } from "./ReadAloudDetails.vue?vue&type=template&id=7f2e0495&scoped=true&"
import script from "./ReadAloudDetails.vue?vue&type=script&lang=js&"
export * from "./ReadAloudDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReadAloudDetails.vue?vue&type=style&index=0&id=7f2e0495&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f2e0495",
  null
  
)

export default component.exports